/**
 * @author Mevan Nirosh
 * @version 1.1
 * @since 06/12/2023
 *
 */

const safeJsonParse = (text) => {
  try {
    return JSON.parse(text)
  } catch {
    return null
  }
}

const isBlob = (v) => typeof Blob !== "undefined" && v instanceof Blob

const extractErrorData = async (error) => {
  const data = error?.response?.data

  // Case 1: Normal JSON object
  if (data && typeof data === "object" && !isBlob(data)) return data

  // Case 2: responseType: "blob" but backend sent JSON error (application/json)
  if (isBlob(data)) {
    const contentType = data.type || ""
    const text = await data.text()

    if (contentType.includes("application/json")) {
      return safeJsonParse(text) || { description: text }
    }

    // Could be plain text error or HTML etc.
    return { description: text }
  }

  // Case 3: Plain string
  if (typeof data === "string")
    return safeJsonParse(data) || { description: data }

  return null
}

const getDescription = (errorData, fallback) => {
  return (
    errorData?.description ||
    errorData?.message ||
    errorData?.response || // your backend uses "response": "Not Found"
    fallback
  )
}

// NOTE: Now async because Blob parsing requires await
export const FetchErrorHandeling = async (
  error,
  setIserror,
  setErrorMessages,
  setIserrorShow,
  setIsUnauhtError,
) => {
  console.log("err", error)

  // 1) Server responded (4xx/5xx)
  if (error?.response) {
    const status = error.response.status
    let errorData = null

    try {
      errorData = await extractErrorData(error)
    } catch (parseErr) {
      console.warn("Error response parse failed:", parseErr)
    }

    // Special handling: 401 -> your existing flow
    if (status === 401) {
      setErrorMessages([])
      setIserror(true)
      setIserrorShow(false)
      setIsUnauhtError(true)
      return
    }

    // Default messages per status (fallbacks)
    const defaultMsgByStatus = {
      400: "Bad request",
      403: "Forbidden",
      404: "Not found",
      405: "Method not allowed",
    }

    const fallback = defaultMsgByStatus[status] || `HTTP ${status}`
    const description = getDescription(errorData, fallback)

    setErrorMessages([`Data Fetching failed: ${description}`])
    setIserror(true)
    setIserrorShow(true)
    return
  }

  // 2) Request was made but no response (network/CORS/timeout)
  if (error?.request) {
    console.log("Request Error", error.request)
    const msg =
      error?.message ||
      "No response received from server. Please check network / server availability."
    setErrorMessages([`Data Fetching failed: ${msg}`])
    setIserror(true)
    setIserrorShow(true)
    return
  }

  // 3) Something else happened
  console.log("Error message", error?.message)
  setErrorMessages([
    `Data Fetching failed: ${error?.message || "Unknown error"}`,
  ])
  setIserror(true)
  setIserrorShow(true)
}
